
import { defineComponent } from 'vue';
import { omit } from 'lodash';
import Cookies from 'js-cookie';

import OidcConsentView from 'client/containers/Oidc/OidcConsentView.vue';

import { XhrConsts } from 'client/util/Constants';
import type {
  OAuthAppData, OAuthClaim, OAuthScope, OAuthScopes,
} from './OAuth.types';

const { xAppData, xRequestedScopes } = XhrConsts;

const hiddenClaims = ['email_verified'];

export default defineComponent({
  name: 'AdminOidcConsent',

  components: {
    OidcConsentView,
  },

  setup() {
    const appDataCookie = Cookies.get(xAppData) as string;
    const scopesCookie = Cookies.get(xRequestedScopes) as string;

    Cookies.remove(xAppData, { path: '' });
    Cookies.remove(xRequestedScopes, { path: '' });

    const appDataString = atob(appDataCookie);
    const scopesString = atob(scopesCookie);

    // eslint-disable-next-line camelcase
    const appData = JSON.parse(appDataString) as OAuthAppData;
    const scopes = JSON.parse(scopesString) as OAuthScopes;

    return {
      appData,
      rememberChoice: true,
      scopes,
    };
  },

  computed: {
    claims(): OAuthClaim[] {
      return Object.values(this.scopes as OAuthScopes)
        .reduce((claims: OAuthClaim[], scope: OAuthScope) => {
          const sanitized = omit(scope.claims, hiddenClaims);

          claims.push(...Object.values(sanitized));

          return claims;
        }, []);
    },
  },

  methods: {
    onConsent() {},

    onCancel() {},
  },
});
